<div #wrapper class="info-popover" (mouseenter)="openPopover()" (mouseleave)="closePopover()">
  <div
    #button
    type="button"
    class="info-popover-button"
    [ngClass]="{ 'info-popover-button--active': isOpen }"
    (click)="togglePopover()"
    (keydown.enter)="togglePopover()"
    tabindex="0"
    aria-label="Info Popover Button"
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen"
  >
    <app-icam-icon [iconName]="'info-circle'" />
  </div>

  @if (isOpen) {
    <div
      class="info-popover-content"
      role="tooltip"
      [attr.aria-hidden]="!isOpen"
      #popoverContent
      [ngStyle]="popoverStyles"
    >
      @if (text && text.length) {
        {{ text }}
      } @else {
        <ng-content></ng-content>
      }
      <div class="info-popover-arrow" aria-hidden="true" [ngStyle]="arrowStyles"></div>
    </div>
  }
</div>
